import "./src/utils/styles/index.css";

require("typeface-inter");
